import { useRouter } from "next/router";
import React from "react";

export const useInitializeRouter = (options: { disabled: boolean } = { disabled: false }) => {
  const { disabled } = options;
  const router = useRouter();
  const loaded = React.useRef<boolean>(false);

  React.useEffect(() => {
    if (!loaded.current && !disabled) {
      router.replace(
        window.location.pathname + window.location.search + window.location.hash,
        undefined,
        {
          shallow: false
        }
      );
      loaded.current = true;
    }
  }, [disabled, router]);
};
